const OWNER_ACCOUNT_CHECK_KEY = 'adia-owner-account-check';

function defaultSessionStorage(): Storage | null {
  return typeof sessionStorage === 'undefined' ? null : sessionStorage;
}

export function markOwnerAccountCheck(
  storage: Storage | null = defaultSessionStorage(),
): void {
  try {
    storage?.setItem(OWNER_ACCOUNT_CHECK_KEY, '1');
  } catch {
    // A blocked sessionStorage API must not weaken the owner gate.
  }
}

export function hasPendingOwnerAccountCheck(
  storage: Storage | null = defaultSessionStorage(),
): boolean {
  try {
    return storage?.getItem(OWNER_ACCOUNT_CHECK_KEY) === '1';
  } catch {
    return false;
  }
}

export function clearOwnerAccountCheck(
  storage: Storage | null = defaultSessionStorage(),
): void {
  try {
    storage?.removeItem(OWNER_ACCOUNT_CHECK_KEY);
  } catch {
    // The marker carries no content and grants no authority.
  }
}
